module.exports = __webpack_public_path__ + "img/qr_cashier.e47221e3.svg";